// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"87":"373070db19ffb20d06bc","201":"eaa33509af244b4e4cd5","683":"36d50213d1a62024952e"}[chunkId] + ".chunk.js";
};